import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

export const admin: Routes = [
  {
    path: '',
    children: [
      {
        path: 'new-password',
        loadComponent: () =>
          import('./new-password.component').then((m) => m.NewPasswordComponent),
      },
    ],
  },
];
@NgModule({
  imports: [RouterModule.forChild(admin)],
  exports: [RouterModule],
})
export class newPasswordRoutingModule {
  static routes = admin;
}
